import React from "react";
import {useSendForm} from "../hooks/send-from.hook"
import {PhoneInput} from "./phone_input"
import {Checkbox} from "./checkbox";
import {useConsentStore} from "../store/consent-store";

export const Form = ({fields, hidden, className, celtype, btnTitle, template, callback}) => {
  const sendForm = useSendForm()

  const [checked, setChecked] = React.useState(false)

  const consent = useConsentStore(state => state.consent)
  const updateConsent = useConsentStore(state => state.consent.updateConsent)

  const handleSend = (e) => {
    e.preventDefault()
    if (checked) {
      sendForm.sendForm(e, callback)
    }
  }

  return (<form className={className ? className : "pu_form"}>
        {fields.map((field) => {
          switch (field.type) {
            case "select":
              return <select className="select_style dop-info" placeholder={field.placeholder}>
                <option>{field.placeholder}</option>
                {field.options.map((option) => {
                  return <option>{option}</option>
                })}
              </select>
            case "textarea":
              return <textarea className={"in_style dop-info"} type={field.type} placeholder={field.placeholder}
                               name={field.name} req={field.required ? "y" : ""}/>
            case "text":
              if (field.name == "phone") {
                return <PhoneInput/>
              }
              return <input className={field.class ? field.class : "in_style"} type={field.type}
                            placeholder={field.placeholder} name={field.name} req={field.required ? "y" : ""}/>
          }
        })}
        <input type="hidden" className="text" value={hidden}/>
        <Checkbox checked={checked} onChange={setChecked}>
          Отправляя заявку Вы даёте согласие на обработку персональных данных и соглашаетесь с нашей <a href="/Politic_204.docx">Политикой конфиденциальности</a>
        </Checkbox>
        <Checkbox checked={consent} onChange={updateConsent}>
          Я ознакомлен (-на) с правилами обработки куки
        </Checkbox>
        <button className="btn_main" template={template} celtype={celtype} onClick={(e) => {
          handleSend(e)
        }}>{btnTitle}</button>
      </form>
  )
}